/* CappyRevolution · Produktseite (assets/cr-product.js)
   Galerie, Live-Vorschau des Wunsch-Patches, Patch-Picker, Extra-Patches, Varianten, Menge,
   Warenkorb (CR.cart.add aus assets/cr.js) und Motiv-Upload fürs Individuelle Patch. */
(function () {
  'use strict';
  const MAX_FILE = 20 * 1024 * 1024;

  function init(root) {
    if (root.dataset.crReady) return;
    root.dataset.crReady = '1';
    const CR = window.CR;
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => [...root.querySelectorAll(s)];
    const kind = root.dataset.kind;
    const form = $('form.cr-buy__form');
    const btn = $('[data-cr-atc]');
    const err = $('[data-cr-err]');
    const sumEl = $('[data-cr-sum]');
    const priceEl = $('[data-cr-price]');
    const box = CR.parseBox(root.dataset.box);
    const slot = $('[data-cr-slot]');
    let price = +root.dataset.price || 0;
    let idx = 0;
    let patch = null;
    const extras = new Map();
    const qty = $('[data-cr-qty]');
    const q = () => Math.max(1, Math.min(99, parseInt(qty?.value, 10) || 1));

    const showErr = (m) => { if (!err) return; err.textContent = m || ''; err.hidden = !m; };

    /* ---------- Galerie ---------- */
    const pic = $('.cr-main-pic');
    function showImage(i, btnEl) {
      idx = i;
      const b = btnEl || $(`.cr-thumbs [data-i="${i}"]`);
      if (b && pic) {
        pic.removeAttribute('srcset');
        pic.src = b.dataset.src;
        pic.srcset = b.dataset.srcset;
        pic.alt = b.dataset.alt;
      }
      $$('.cr-thumbs [data-i]').forEach((x) => x.setAttribute('aria-pressed', String(+x.dataset.i === i)));
      updatePreview();
    }
    root.addEventListener('click', (e) => {
      const t = e.target.closest('.cr-thumbs [data-i]');
      if (t) showImage(+t.dataset.i, t);
    });

    /* ---------- Live-Vorschau ---------- */
    function updatePreview() {
      if (!slot) return;
      const live = !!(box && patch && idx === 0);
      slot.hidden = !live;
      const tag = $('[data-cr-live]'); if (tag) tag.hidden = !live;
      const note = $('[data-cr-live-note]'); if (note) note.hidden = !live;
      const dock = $('[data-cr-dock]'); if (dock) dock.hidden = live || !patch;
    }
    if (slot && box) CR.slot(slot, box);

    function setPatch(p, rip = true) {
      if (!p) return;
      const changed = patch && patch.h !== p.h;
      patch = p;
      const img = CR.img(p.i, 360);
      if (slot && box) {
        CR.swapPatch(slot, img, rip && changed);
        if (idx !== 0 && changed) showImage(0);
      }
      const di = $('[data-cr-dock-img]'); if (di) { di.src = img; di.alt = 'Patch ' + p.n; }
      const dc = $('[data-cr-dock-code]'); if (dc) { dc.textContent = p.c || p.n; }
      const sel = $('[data-cr-pk-sel]');
      if (sel) {
        sel.innerHTML = '';
        sel.append('Ausgewählt: ');
        if (p.c) { const c = document.createElement('span'); c.className = 'cr-code'; c.textContent = p.c; sel.append(c, ' '); }
        const b = document.createElement('b'); b.textContent = p.n; sel.append(b, ' · im Set-Preis enthalten');
      }
      const label = CR.patchLabel(p);
      const set = (s, v) => { const el = $(s); if (el) el.value = v; };
      set('[data-cr-prop-patch]', label);
      set('[data-cr-prop-handle]', p.h);
      set('[data-cr-prop-img]', img);
      updatePreview();
      sum();
    }

    /* ---------- Picker ---------- */
    let picker = null;
    if (kind === 'cap' && CR.mountPicker) {
      const data = CR.patchData('cr-patches-' + root.dataset.crPdp);
      const def = data.find((p) => p.h === root.dataset.defaultPatch) || data[0];
      picker = CR.mountPicker({
        data,
        grid: $('[data-cr-pk-grid]'), chips: $('[data-cr-pk-chips]'), search: $('[data-cr-pk-search]'), count: $('[data-cr-pk-count]'),
        selected: def && def.h, light: true,
        onPick: (p) => setPatch(p, true),
      });
      if (def) setPatch(def, false);
      else if (btn) { btn.disabled = true; showErr('Keine Patches gefunden. Bitte die Patch-Kollektion in den Theme-Einstellungen prüfen.'); }
    }

    /* ---------- Extra-Patches ---------- */
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-cr-extra]'); if (!b) return;
      const id = b.dataset.crExtra;
      const on = !extras.has(id);
      if (on) extras.set(id, { id: +id, price: +b.dataset.price, img: b.closest('.cr-extra')?.querySelector('img')?.src });
      else extras.delete(id);
      b.setAttribute('aria-pressed', String(on));
      b.textContent = on ? 'Dabei ✓' : b.dataset.label;
      sum();
    });

    /* ---------- Varianten ---------- */
    const vjson = $('[data-cr-variants]');
    const variants = vjson ? JSON.parse(vjson.textContent) : null;
    const idInput = $('[data-cr-variant]');
    if (variants) {
      root.addEventListener('click', (e) => {
        const c = e.target.closest('[data-cr-option] [data-value]'); if (!c) return;
        const grp = c.closest('[data-cr-option]');
        [...grp.querySelectorAll('[data-value]')].forEach((x) => x.setAttribute('aria-pressed', String(x === c)));
        const lbl = grp.querySelector('[data-cr-option-val]'); if (lbl) lbl.textContent = c.dataset.value;
        const chosen = $$('[data-cr-option]').map((g) => g.querySelector('[aria-pressed="true"]')?.dataset.value);
        const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
        if (!v) { btn.disabled = true; btn.textContent = 'Nicht verfügbar'; return; }
        idInput.value = v.id;
        price = v.price;
        if (priceEl) priceEl.textContent = CR.money(v.price);
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
        sum();
      });
    }

    /* ---------- Menge (Patches, Individuell) ---------- */
    root.addEventListener('click', (e) => {
      const s = e.target.closest('[data-cr-step]'); if (!s || !qty) return;
      qty.value = Math.max(1, Math.min(99, q() + +s.dataset.crStep)); sum();
    });
    qty?.addEventListener('input', sum);

    /* ---------- Summe ---------- */
    function sum() {
      let t = price * (qty ? q() : 1);
      extras.forEach((x) => { t += x.price; });
      if (sumEl) sumEl.textContent = CR.money(t);
      const line = $('[data-cr-atc-line]');
      if (line) {
        const base = line.dataset.base || (line.dataset.base = line.textContent.replace(/ \+ Patch.*$/, ''));
        let s = base;
        if (patch) s += ' + Patch ' + (p => p.c || p.n)(patch);
        if (extras.size) s += ` + ${extras.size} Extra-Patch${extras.size > 1 ? 'es' : ''}`;
        line.textContent = s;
      }
    }
    sum();

    /* ---------- Motiv-Upload ---------- */
    const file = $('[data-cr-file]');
    const fileErr = $('[data-cr-file-err]');
    const fileLabel = $('[data-cr-file-label]');
    function checkFile() {
      const f = file?.files?.[0];
      let m = '';
      if (f && f.size > MAX_FILE) m = `Die Datei ist ${(f.size / 1048576).toFixed(1)} MB groß. Erlaubt sind maximal 20 MB.`;
      else if (f && !/\.(png|jpe?g|svg|pdf)$/i.test(f.name)) m = 'Bitte eine PNG-, JPG-, SVG- oder PDF-Datei wählen.';
      if (fileErr) { fileErr.textContent = m; fileErr.hidden = !m; }
      if (fileLabel) fileLabel.innerHTML = f ? `<b>${f.name.replace(/[<>&"]/g, '')}</b> · ${(f.size / 1048576).toFixed(1)} MB` : '<b>Datei auswählen</b> oder hierher ziehen';
      return !m;
    }
    if (file) {
      file.addEventListener('change', checkFile);
      const drop = file.closest('.cr-upload__drop');
      ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add('cr-drag'); }));
      ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, () => drop.classList.remove('cr-drag')));
      drop.addEventListener('drop', (e) => { e.preventDefault(); if (e.dataTransfer?.files?.length) { file.files = e.dataTransfer.files; checkFile(); } });
    }

    /* ---------- Warenkorb ---------- */
    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      showErr('');
      if (btn.disabled) return;
      const label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
      try {
        if (kind === 'custom') {
          if (!checkFile()) throw new Error(fileErr?.textContent || 'Datei prüfen');
          const fd = new FormData(form);
          if (!file?.files?.length) { fd.delete('properties[Motiv]'); fd.set('properties[Motiv]', 'Datei folgt per E-Mail'); }
          if (!fd.get('properties[Hinweis]')) fd.delete('properties[Hinweis]');
          fd.set('quantity', q());
          fd.append('sections', 'cr-cart-drawer');
          const root0 = (CR.cfg.routes?.root || '/').replace(/\/?$/, '/');
          const r = await fetch(root0 + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          const j = await r.json();
          if (!r.ok || j.status) throw new Error(j.description || j.message || 'Upload fehlgeschlagen');
          const cart = await (await fetch(root0 + 'cart.js')).json();
          CR.renderCart(j.sections, cart);
          CR.toast('Im Warenkorb', pic?.src);
          setTimeout(() => CR.openDrawer('cart'), 350);
          form.reset(); checkFile();
        } else {
          const items = [];
          const main = { id: +idInput.value, quantity: qty ? q() : 1 };
          if (kind === 'cap' && patch) {
            main.properties = { 'Wunsch-Patch': CR.patchLabel(patch), _patch: patch.h, _patch_img: CR.img(patch.i, 200) };
          }
          items.push(main);
          extras.forEach((x) => items.push({ id: x.id, quantity: 1 }));
          await CR.cart.add(items, { toastImg: patch ? CR.img(patch.i, 120) : pic?.src });
        }
      } catch (ex) {
        showErr(ex.message);
      } finally {
        btn.disabled = false; btn.textContent = label;
      }
    });

    if (location.hash === '#patch') setTimeout(() => $('#patch')?.scrollIntoView({ behavior: 'smooth', block: 'center' }), 300);
  }

  const boot = (scope = document) => scope.querySelectorAll('[data-cr-pdp]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => boot()) : boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
